import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path d=\"M12 100q44-40 84 0-40 40-84 0\"></path><circle cx=\"56\" cy=\"100\" r=\"22\" fill=\"var(--mc-avatar)\"></circle><circle cx=\"64\" cy=\"96\" r=\"13\"></circle><path d=\"M104 100q44-40 84 0-40 40-84 0\"></path><circle cx=\"148\" cy=\"100\" r=\"22\" fill=\"var(--mc-avatar)\"></circle><circle cx=\"156\" cy=\"96\" r=\"13\"></circle>", 6)
  ]))]))
}
export default { render: render }